export default "November 2, 2019";